import { Skeleton } from '@/components/ui/skeleton';
import { FC } from 'react';

type Props = {
	quantity?: number;
};

const NewOrderSummarySkeleton: FC<Props> = ({ quantity = 4 }) => {
	return Array.from({ length: quantity }).map(() => (
		<div className='h-5 flex items-center gap-4'>
			<Skeleton className='size-4 rounded-full' />
			<Skeleton className='h-3 w-30' />
			<Skeleton className='h-3 w-10 ml-auto' />
		</div>
	));
};

export default NewOrderSummarySkeleton;
